import { render, staticRenderFns } from "./vote-detail.vue?vue&type=template&id=232e4a8f&scoped=true&"
import script from "./vote-detail.vue?vue&type=script&lang=js&"
export * from "./vote-detail.vue?vue&type=script&lang=js&"
import style0 from "./vote-detail.vue?vue&type=style&index=0&id=232e4a8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e4a8f",
  null
  
)

export default component.exports